<template>
  <div class="assetselection">
    <section class="toolbar">
      <div class="toolbar-container">
        <!--<a href="#" onclick="window.history.go(-1)"><img src="/static/images/back.png"></a>-->
        <h1>Select Vehicle</h1>
      </div>
      <div class="hos-container" v-show="isSafety == 1">
        <a href="#" style="color:#ffffff;" v-on:click="skipAssetSelection();">Skip</a>
      </div>
    </section>

    <section class="search-section">

      <div class="search-section-container">

        <div class="input-group">
          <input type="text" class="form-control" v-on:keyup="searchVehicle(this)" placeholder="Search for Vehicle" id="search" name="search">
          <div class="input-group-btn">
            <button class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="clearfix"></div>

    <section class="list-view list-view-new">
      <div class="list-view-title">
        <h2>All Vehicles</h2>
      </div>

      <div class="list-container">
        <div v-if="noAssets" class="custom-no-assets">No assets mapped to your account. Please contact the administrator.<br>
          <button id="asset-selection-logout-button" v-on:click="logoutFromAssetSelection(this)" class="btn btn-default">Logout</button>
        </div>
        <ul v-else id="vehicles_list">

          <li v-for="val in items" :id="'asset-'+val.id" v-bind:key="val.id" v-on:click="vehicleSelected(val)">
            <div class="list-view-left" v-if="val.unit_number_id">{{ val.vin }} ({{ val.unit_number_id }})</div>
            <div class="list-view-left" v-else>{{ val.vin }}</div>
            <div class="list-view-right">
              <!-- {{if eq $.selected_vehicle $val.Vin}} -->
              <img v-if="ifSelectedVehicleEqual" src="/static/images/tick-color.png">
              <!-- {{else}} -->
              <img v-if="ifSelectedVehicleNotEqual" src="/static/images/tick.png">
              <!-- {{end}} -->
            </div>
          </li>
          <!-- {{end}} -->
        </ul>
      </div>
    </section>
     <section class="bottom-sticky">
         NOTE: If you are a first time user please refer to the user manual given in the about section of the application to get a basic understanding of how the application works.
      </section>
  </div>
</template>

<script>
export default {
  name: "assetselection",
  data: () => ({
    ifSelectedVehicleEqual: false,
    ifSelectedVehicleNotEqual: true,
    items: [],
    noAssets: false,
    isSafety: 0,
  }),
  mounted: function() {
    this.isSafety = this.$route.query.is_safety;
    this.call();
  },
  methods: {
    searchVehicle: function() {
      var input, filter, table, tr, td, i;
      input = document.getElementById("search");
      filter = input.value.toUpperCase();
      table = document.getElementById("vehicles_list");
      tr = table.getElementsByTagName("li");

      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("div")[0];
        if (td) {
          if (td.innerHTML.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },
    skipAssetSelection: function() {
      this.$router.push(
        "/operator/home-page"
      );
    },
    vehicleSelected: function(obj) {
      var result = confirm("Are you sure to select this vehicle? " + obj.vin);
      if (result) {
        this.$router.push(
          "/operator/home-page?selected_vehicle=" + obj.id + "&vin=" + obj.vin
        );
      }
    },
    logoutFromAssetSelection: function() {
      this.$router.push(
        "/operator/logout"
      );
    },
    call: function() {
      var self = this;
      self.$config.loading=true;
      $.ajax({
        url: self.$config.API + "/v1/assets/asset-selection",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(res) {self.$config.loading=false;

          var data = res.data;
          console.log(data.assets)
          if (res.status == "success") {
            self.items = data.assets;
            if (self.items == null) {
              self.noAssets = true;
            }
          }
        },
        error: function(jqXHR, exception, textstatus) {self.$config.loading=false;

          //if session expired
         if(textstatus==="timeout") {
            alert("Request timeout");
        } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push(
              "/v1/operator/login"
            )
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }

        }

      });

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>



// WEBPACK FOOTER //
// src/components/assetselection.vue